import React, { useCallback, useMemo } from "react";
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import fieldPropTypes from "./field-prop-types";
import env from "../utils/env";
import {
  createPayPalPaymentRequest,
  approvePayPalPaymentRequest,
  cancelPayPalPaymentRequest
} from "../api/paypal";

const PayPalButton = ({ field, appData }) => {
  const {
    handleButtonClick,
    handleValuesChange,
    values: { member_id, logged_in_member_id, cost }
  } = appData;

  const initialOptions = useMemo(
    () => ({
      intent: "authorize",
      "client-id": env("PAYPAL_CLIENT_ID"),
      "merchant-id": env("PAYPAL_MERCHANT_ID")
    }),
    []
  );

  const price = field?.data?.price || cost;

  const amount = useMemo(
    () => parseFloat(price.replace(/[^\d.,]/g, "")),
    [price]
  );
  const payload = {
    amount,
    member_id,
    logged_in_member_id
  };

  const handleApprove = useCallback(
    ({ orderID, payerID }) => {
      approvePayPalPaymentRequest(orderID, payerID);
      handleValuesChange({
        paypal_token: orderID,
        lastCardNumber: appData.values["cc_info.masked_card_number"],
        "cc_info.masked_card_number": "PayPal",
        existing_card: "false"
      });
      handleButtonClick(field.name, field.text, field.action);
    },
    [handleButtonClick]
  );

  const handleCancel = useCallback(({ orderID }) => {
    cancelPayPalPaymentRequest(orderID);
    handleValuesChange({
      paypal_token: "",
      "cc_info.masked_card_number": "",
      existing_card: "false"
    });
  }, []);

  return (
    <PayPalScriptProvider options={initialOptions}>
      <PayPalButtons
        style={{ color: "white", ...(appData?.isPulse && { height: 48 }) }}
        className='paypal-iframe-container'
        fundingSource='paypal'
        createOrder={async () => {
          return createPayPalPaymentRequest(payload).then(data => data.token);
        }}
        onApprove={handleApprove}
        onCancel={handleCancel}
      />
    </PayPalScriptProvider>
  );
};

PayPalButton.propTypes = fieldPropTypes;

export default PayPalButton;
